import React, { FunctionComponent } from 'react';
import { View } from '@react-pdf/renderer';
import { useStyles } from './styles';

export const PDFDivider: FunctionComponent = () => {
  const styles = useStyles();
  return <View style={styles.root} />;
};
